import { render, staticRenderFns } from "./nintyFivePercent.vue?vue&type=template&id=75288718&scoped=true"
import script from "./nintyFivePercent.vue?vue&type=script&lang=js"
export * from "./nintyFivePercent.vue?vue&type=script&lang=js"
import style0 from "./nintyFivePercent.vue?vue&type=style&index=0&id=75288718&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75288718",
  null
  
)

export default component.exports